import founderLetter from "./founderLetter.json";

const u = (id, w) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&q=80&w=${w}`;
const p = (id, w) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMAGES = {
  hero: { src: u("1622610607501-32ac9c927216", 1920), srcSet: `${u("1622610607501-32ac9c927216", 800)} 800w, ${u("1622610607501-32ac9c927216", 1400)} 1400w, ${u("1622610607501-32ac9c927216", 2200)} 2200w`, alt: "Parents and their child walking through a golden field at sunset" },
  momLift: { src: u("1484665754804-74b091211472", 1000), alt: "A mother lifting her laughing toddler into the air outdoors" },
  familyDinner: { src: p(3807395, 1100), alt: "A family laughing together around the dinner table" },
  dadKids: { src: u("1609220136736-443140cffec6", 800), alt: "A smiling dad carrying his two young kids" },
  cooking: { src: p(4259140, 800), alt: "Parents and kids cooking together in the kitchen" },
  dadShoulders: { src: u("1597524678053-5e6fef52d8a3", 1000), alt: "A dad carrying his child on his shoulders at the beach, mum laughing beside them" },
  bikeRide: { src: p(1128318, 1600), alt: "Parents teaching their child to ride a bike in the park" },
  meadow: { src: u("1588979355313-6711a095465f", 1600), alt: "A family sitting together among wildflowers in warm evening light" },
};

export const HERO = {
  title: "Woven",
  tagline: "Embracing balance to live a life fulfilled.",
  sub: "One thread is a start. Two threads is a life worth living.",
};

export const PROBLEMS = [
  "Work never stops — but your family can't wait.",
  "You provide everything except your presence.",
  "Your partner is carrying more than they should.",
];

export const EXPLANATION =
  "Woven is a shared family life app that helps couples schedule their roles — as partners, parents, and people — so nothing important gets left behind.";

export const HIGHLIGHTS = [
  "Shared family calendar with colour-coded time blocks",
  "Role balance nudges when work takes over",
  "Local activity and dinner ideas for the whole family",
  "Private play date scheduling with other Woven families",
];

export const FOUNDER_LETTER = founderLetter;

export const STEPS = [
  "Set up your family profile — add both partners, kids, work hours, and existing commitments.",
  "See your week together — colour-coded blocks show who's doing what and when.",
  "Live more of what matters — Woven nudges you when work takes over and suggests ideas for family time.",
];

export const WAITLIST = {
  heading: "Be the first to bring balance home.",
  sub: "Woven is coming soon. Join the waitlist and we'll let you know the moment it's ready.",
  cta: "Join the Waitlist",
  note: "No spam. Just Woven.",
};

export const CONTACT_EMAIL = "hello@thewovenapp.com.au";

export const SOCIAL = { instagram: "#", facebook: "#" };

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
